import { render, staticRenderFns } from "./MobilePreviewAlim.vue?vue&type=template&id=027a9020"
import script from "./MobilePreviewAlim.vue?vue&type=script&lang=js"
export * from "./MobilePreviewAlim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports